function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9c0 4.962 3.98 9 8.872 9 2.12 0 4.17-.77 5.777-2.169a1.027 1.027 0 00.108-1.435.992.992 0 00-1.414-.11 6.807 6.807 0 01-4.471 1.679c-3.786 0-6.867-3.126-6.867-6.965 0-3.84 3.081-6.965 6.867-6.965 3.544 0 6.468 2.737 6.83 6.236l-.677-.86a.992.992 0 00-1.41-.162c-.433.35-.504.99-.159 1.43l2.734 3.482 3.432-2.774c.433-.349.505-.99.16-1.429a.992.992 0 00-1.41-.162l-.66.534C17.37 3.68 13.541 0 8.871 0 3.98 0 0 4.037 0 9zm7-3.02v4.98l3.996.04h.01a.988.988 0 00.994-.97.987.987 0 00-.985-.989l-2.025-.02v-3.04A.988.988 0 007.994 5 .987.987 0 007 5.98z",
  fill: "#fff"
});

var SvgWaitFree = function SvgWaitFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none"
  }, props), _ref);
};

export default SvgWaitFree;


//////////////////
// WEBPACK FOOTER
// ../svgs/WaitFree.svg
// module id = O3Ee
// module chunks = 6